'use strict'

var caseSensitiveTransform = require('./case-sensitive-transform')

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/util/case-insensitive-transform.js
// module id = 194
// module chunks = 168707334958949